import { DemandPosition } from '../../services/demandService';
import { aggregateToMaterialsDic, MaterialExposureDictionary } from '../../utils/positionUtils';

// Re-export the unified type so existing imports don't break
export type { MaterialExposureDictionary as materialExposureDictionary } from '../../utils/positionUtils';

export const aggregateDemandPositionsToMaterialsDic = (
  demandPositions: DemandPosition[],
  selMaterial?: string,
  materialPriceDic?: Record<string, number>,
  getRateToBase?: (currency: string) => number | null,
): Record<string, MaterialExposureDictionary> => {
  return aggregateToMaterialsDic(demandPositions, materialPriceDic || {}, selMaterial);
};
